import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp32};

  p {
    margin: 0;
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};

    strong {
      font-family: ${props => props.theme.texts.bodyMBold.fontFamily};
    }
  }

  p:nth-child(2) {
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: 9px;
    line-height: 11px;
    display: flex;
    gap: 4px;
  }
`
